import React, {Component} from 'react'
import Text from "@amzn/meridian/text";
import {rtsRowMapping} from '../../commons/dataStore/PackageResultsData'
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import CommonFilters from "../../commons/CommonFilters"
import Table, {TableCell, TableRow} from "@amzn/meridian/table";
import Link from "@amzn/meridian/link";
import {FiltersStateContext} from '../../commons/context/FiltersStateContext';
import {handlePackageStateToGenericTextMapping} from "../../commons/CommonUtils";
import Loader from "@amzn/meridian/loader";
import {FormattedMessage} from "react-intl";
import Icon from "@amzn/meridian/icon";
import chevronDownSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-down-small";
import chevronRightSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-right-small";
import {PackageTypes_Reverse} from "../../commons/dataStore/FilterDataStore";
import RefreshTimer from "../../commons/RefreshTimer";
import {PAGE_HEADERS, RTS_PAGE_HEADER_METRIC} from "../../commons/constants/CommonConstants";
import PageHeader from "../../commons/PageHeader";
import {isINRegion} from "../../util/CommonUtils";
import Box from "@amzn/meridian/box";
import { processConditionalMetrics } from '../../util/MetricUtils';

export default class RTSDataUI extends Component {

 static contextType = FiltersStateContext;
 constructor(props) {
    super(props)
    this.state = {
          expandedSections : [],
          view : "RTS_VIEW"
    }

    this.toggleRow = section => {

        if (this.state.expandedSections.indexOf(section) !== -1) {
            this.setState({
             expandedSections : this.state.expandedSections.filter(expandedSection => expandedSection !== section)}
            )
        } 
        else  {
           this.setState({
             expandedSections : this.state.expandedSections.concat(section)

            })
        } 
    }

    this.getMetricFromPackageToColumnMap = (section, column, direction) => {

        var sectionData = this.props.data.filter(status => status.packageStatus === section);
        var timeToMetricDataMapForSection = sectionData && sectionData.length > 0 ? sectionData : [];
        var columnToMetricEntity = direction ?  (timeToMetricDataMapForSection.find(section => section.metaDataMap ? section.metaDataMap.direction === direction : null) ? 
        timeToMetricDataMapForSection.find(section => section.metaDataMap ? section.metaDataMap.direction === direction : null).columnToViewDataMap : []) :
            (timeToMetricDataMapForSection.length > 0 ? timeToMetricDataMapForSection[0].columnToViewDataMap : []) 
        if (column === "_MIN") {  
            column = JSON.stringify(columnToMetricEntity).match(/[0-9]*_MIN/g);
        }
        return columnToMetricEntity[column] ? columnToMetricEntity[column].value : 0
    }
    
        /**
        * This calculates total count for section metric
        */
    this.getSectionMetricFromSubsectionData = (section, column) => {

        var totalCount = 0;
        section.Subsections.length > 0 ? 
        section.Subsections.map(subsection =>  subsection.Section ?
                subsection.Subsections.map(s => totalCount+= Number(this.getMetricFromPackageToColumnMap((s.localeCompare(subsection.Section) !== 0 ? s.split(" (", 1)[0]: ""), column,  s.split(" (", 2)[1] ? s.split(" (", 2)[1].split(")" , 1)[0] : ""))) :
        (totalCount += Number(this.getMetricFromPackageToColumnMap(subsection.localeCompare(section.Section) !== 0 ? subsection.split(" (", 1)[0]: "", column,  subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : "")))) :
        //In case when there is no subsection
        totalCount += Number(this.getMetricFromPackageToColumnMap(section.Section, column))
        return totalCount

    }

   this.backendStateToMetricMapping = (subsection) => {

    return subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : subsection;
  }

    this.isSectionExpanded = section => {
        return (this.state.expandedSections.indexOf(section) !== -1);
    }

    this.constructState = (section, timeColumn) => {

        let subsections = Array.isArray(section)  ? [].concat.apply([], section): section;
        var values = {
            cycles : this.context.selectedFilterValues.cycles,
            startPDD : this.context.selectedFilterValues.startPDD,
            endPDD : this.context.selectedFilterValues.endPDD,
            packageTypes  : this.context.selectedFilterValues.packageTypes_Reverse ? [].concat.apply([], 
                this.context.selectedFilterValues.packageTypes_Reverse.map(packageType => {return PackageTypes_Reverse[packageType]})) : [], 
            dwellStartTime : timeColumn,
            dwellEndTime : "0_MIN",
            packageStatuses : Array.isArray(subsections) ? subsections : [subsections],
            leg : "Reverse",
            page : "DWELL"
        } 

        //Redirect to search path
        var path = window.location.href;
        var searchPath = path[path.length - 1] === "/" ? path + "packageSearch/" : path + "/packageSearch/";
        return searchPath + JSON.stringify(values).replace('/','%2f');
    }

    this.getAggregateRTSMetricRowData = () => {
        const filteredAggregatedRTSMetrics = this.props.data.filter(status => Object.keys(RTS_PAGE_HEADER_METRIC).includes(status.packageStatus));
        return filteredAggregatedRTSMetrics.map(metric => ({
            metricName: metric.packageStatus,
            metricValue: metric.columnToViewDataMap.TOTAL.value == null ? 0 : metric.columnToViewDataMap.TOTAL.value,
            metricVisibleName: RTS_PAGE_HEADER_METRIC[metric.packageStatus].metricVisibleName,
            metricVisibleUnit: metric.columnToViewDataMap.TOTAL.value === "1" ? RTS_PAGE_HEADER_METRIC[metric.packageStatus].metricVisibleUnit.slice(0, -1) : RTS_PAGE_HEADER_METRIC[metric.packageStatus].metricVisibleUnit
        }));
    }

}
 
render() {
    // Process conditional metrics to filter out metrics with no data
    const processedRtsRowMapping = processConditionalMetrics(this.props.data, [...rtsRowMapping]);
  
    const formattedIdPrefix = "commons.";
    let Columns = this.props.data.length > 0 ? [JSON.stringify(this.props.data).match(/[0-9]*_MIN/g)[0]] : []
    const aggregateRTSMetricRowData = this.getAggregateRTSMetricRowData()
    return (
    <Column spacing="medium" spacingInset={this.props.spacingInset_shorthand2}>
        <PageHeader {...PAGE_HEADERS.RTS}/>
        <CommonFilters view={this.state.view} />
        {
            (isINRegion() && !this.props.isLoading && aggregateRTSMetricRowData.length > 0) ?
            <Row spacing="medium" spacingInset={this.props.spacingInset_shorthand4} width="100%">
                {
                    aggregateRTSMetricRowData.map(aggregateMetricRow => (
                        <Box type="outline" spacingInset="medium">
                            <Text type="h100">
                                <b><FormattedMessage id={formattedIdPrefix.concat(aggregateMetricRow.metricVisibleName.toLocaleLowerCase().split(' ').join('_'))} defaultMessage={aggregateMetricRow.metricVisibleName}/></b>
                            </Text>
                            <Text type="d50">
                              <Link href = { this.constructState(aggregateMetricRow.metricName, JSON.stringify(this.props.data).match(/[0-9]*_MIN/g)[0])}
                                    type="secondary"> {aggregateMetricRow.metricValue} </Link>
                            </Text>
                            <Text type="b300" color={"secondary"}>
                                <FormattedMessage id={formattedIdPrefix.concat(aggregateMetricRow.metricVisibleUnit.toLocaleLowerCase().split(' ').join('_'))} defaultMessage={aggregateMetricRow.metricVisibleUnit} />
                            </Text>
                        </Box>
                    ))
                }
            </Row> : null
        }

        <RefreshTimer deps={[this.props.data]}/>
        <Row widths={["grid-8"]}>
            <div>
            <Table spacingInset="medium"  spacing="small">
                <TableRow alignmentHorizontal = "left">
                    <TableCell>
                       <Text type="h100">
                           <FormattedMessage id="rts.status" defaultMessage="Status"/>
                       </Text>
                    </TableCell>
                    <TableCell alignmentHorizontal = "right"><Text type="h100">
                        <FormattedMessage id="rts.today" defaultMessage="Today"/>
                    </Text></TableCell>
                </TableRow>
                { this.props.isLoading ? <TableRow><TableCell columnSpan = {7} alignmentHorizontal = "center"><Loader/></TableCell></TableRow>: 
                     this.props.data && this.props.data.length > 0 && processedRtsRowMapping.map(section => (

                    <TableRow key={section.Section} open={this.isSectionExpanded(section.Section)} onClick={() => this.toggleRow(section.Section)}>
                        <TableCell  alignmentHorizontal = "left"><FormattedMessage id ={formattedIdPrefix.concat(section.Section.split(' ').join('_').toLocaleLowerCase())} defaultMessage={section.Section}/></TableCell>
                        { Columns.map( col =>
                        <TableCell alignmentHorizontal = "right">
                            {this.getSectionMetricFromSubsectionData(section, col) !== 0 ? 
                            <Link href = {this.constructState(section.Subsections.length > 0 ? section.Subsections.map( subsection => {return subsection.Section ? subsection.Subsections.filter(sub=> sub !== subsection.Section) : subsection}) : section.Section, JSON.stringify(this.props.data).match(/[0-9]*_MIN/g)[0])} type="secondary">
                                {this.getSectionMetricFromSubsectionData(section, col)}
                            </Link> : this.getSectionMetricFromSubsectionData(section, col)}
                        </TableCell> )}

                        { section.Subsections.map(subsection => subsection.Section ? subsection.Subsections.map(sub=> 

                                   sub === subsection.Section ? 
                                  <TableRow key={subsection.Section} open={this.isSectionExpanded(subsection.Section)} onClick={() => this.toggleRow(subsection.Section)}>
                                      <TableCell alignmentHorizontal = "left">
                                         <Row spacingInset="none none none medium">
                                                <Icon tokens={this.isSectionExpanded(subsection.Section) ? chevronDownSmallTokens : chevronRightSmallTokens}/>
                                                <FormattedMessage id ={formattedIdPrefix.concat(subsection.Section.toLocaleLowerCase().split(' ').join('_'))} defaultMessage={subsection.Section}/></Row>
                                    </TableCell>
                                { Columns.map( col => <TableCell alignmentHorizontal = "right">
                                {this.getSectionMetricFromSubsectionData(subsection, col) !== 0 ? 
                                    <Link href = {this.constructState(subsection.Subsections.length > 0 ? subsection.Subsections.filter( s => s !== subsection.Section) : 
                                        subsection.Section, JSON.stringify(this.props.data).match(/[0-9]*_MIN/g)[0])} type="secondary">
                                         {this.getSectionMetricFromSubsectionData(subsection, col)}
                                     </Link> : this.getSectionMetricFromSubsectionData(subsection, col)}
                                    </TableCell> )} </TableRow> :
                                 this.isSectionExpanded(subsection.Section) ? <TableRow>
                                 <TableCell  alignmentHorizontal = "left"><Row spacingInset="none none none xlarge"><FormattedMessage id ={formattedIdPrefix.concat(this.backendStateToMetricMapping(sub).toLocaleLowerCase().split(' ').join('_'))} defaultMessage={this.backendStateToMetricMapping(sub)}/></Row></TableCell> 
                                { Columns.map( col =>

                                <TableCell alignmentHorizontal = "right">
                                    {this.getMetricFromPackageToColumnMap(sub.split(" (", 1)[0], col, sub.split(" (", 2)[1] ? sub.split(" (", 2)[1].split(")" , 1)[0] : "").toString() !== "0"  ? 
                                 <Link href = {this.constructState(sub, JSON.stringify(this.props.data).match(/[0-9]*_MIN/g)[0])} type="secondary">
                                     {this.getMetricFromPackageToColumnMap(sub.split(" (", 1)[0], col, sub.split(" (", 2)[1] ? sub.split(" (", 2)[1].split(")" , 1)[0] : "")}
                                </Link> : this.getMetricFromPackageToColumnMap(sub.split(" (", 1)[0], col, sub.split(" (", 2)[1] ? sub.split(" (", 2)[1].split(")" , 1)[0] : "")}
                                </TableCell> )} </TableRow>
                        
                            : null ):

                            <TableRow>
                                <TableCell alignmentHorizontal = "left" ><Row spacingInset="none none none medium"><FormattedMessage id ={formattedIdPrefix.concat(handlePackageStateToGenericTextMapping("RTS", section.Section, subsection, "DEFAULT_VIEW", this.props.isRtsAgeingGenericLabelsEnabled).toLocaleLowerCase().split(' ').join('_'))} defaultMessage={subsection}/></Row></TableCell>
                                { Columns.map(col =>
                            
                            <TableCell alignmentHorizontal = "right">
                                {this.getMetricFromPackageToColumnMap(subsection.split(" (", 1)[0], col, subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : "").toString() !== "0" ?
                                <Link href = {this.constructState(subsection, JSON.stringify(this.props.data).match(/[0-9]*_MIN/g)[0])} type="secondary">
                                    {this.getMetricFromPackageToColumnMap(subsection.split(" (", 1)[0], col, subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : "")}
                                </Link> : this.getMetricFromPackageToColumnMap(subsection.split(" (", 1)[0], col, subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : "")}
                            </TableCell>)}
                        </TableRow>)}
                        </TableRow>
                ))}
            </Table>
        </div>
    </Row>
</Column>
)
 }
}
                    


// WEBPACK FOOTER //
// ./src/components/rts/RTSDataUI.js